import React, { useState, useEffect, useRef } from 'react';
// import { createPopper } from "@popperjs/core";
import Modal from 'components/Modals/Modal.js';
// Alertify
import alertify from 'alertifyjs';

const StockTagsDropdown = ({
  tag_id,
  tag_cantidad,
  tag_nombre,
  info,
  URIExtension,
  ...props
}) => {
  function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] =
      useState(initialIsVisible);
    const ref = useRef(null);

    const handleHideDropdown = (event) => {
      if (event.key === 'Escape') {
        closeDropdownPopover();
      }
    };

    const handleClickOutside = (event) => {
      if (ref.current && !btnDropdownRef.current.contains(event.target)) {
        closeDropdownPopover();
      }
    };

    useEffect(() => {
      document.addEventListener('keydown', handleHideDropdown, true);
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('keydown', handleHideDropdown, true);
        document.removeEventListener('click', handleClickOutside, true);
      };
    });

    return { ref, isComponentVisible, setIsComponentVisible };
  }

  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    // createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
    //   placement: "left-start",
    // });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible();

  // useState
  const [idData, setIdData] = useState(tag_id);
  const [tagCantidad, setTagCantidad] = useState(tag_cantidad);
  const [tagNombre, setTagNombre] = useState(tag_nombre);
  // URI
  const URI = '/api/update/';
  // URI For Remove (Set State to 2)
  const URIDelete = '/api/delete/';
  // Alerts
  const [alert, setAlert] = useState('');

  if (alert) {
    if (!alertify.errorAlert) {
      alertify.dialog(
        'errorAlert',
        function factory() {
          return {
            build: function () {
              var errorHeader =
                '<span class="fas fa-info-circle fa-2x" ' +
                'style="vertical-align:middle;color:#77acf1;">' +
                '</span><span style="vertical-align:middle;font-size:1.15em;margin: 0 .5em;">Info</span>';
              this.setHeader(errorHeader);
            },
          };
        },
        true,
        'alert'
      );
    }
    alertify.errorAlert(alert, function () {
      if (modalEdit.current) {
        modalEdit.current.close();
      }
      if (modalRemove.current) {
        modalRemove.current.close();
      }
      alertify.success('Muy bien!');
    });
    setAlert('');
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      setIdData(tag_id);
      setTagCantidad(tag_cantidad);
      setTagNombre(tag_nombre);
    }
    return () => {
      mounted = false;
    };
  }, [tag_id, tag_cantidad]);

  function submitDataEdit() {
    var datos = [];

    datos.push({
      idData: idData,
      tagCantidad: tagCantidad,
    });

    fetch(URI + URIExtension, {
      method: 'PUT',
      credentials: 'same-origin',
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.success) {
          setAlert(json.message);
          props.recibir();
        } else {
          setAlert(json.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setMensajeData(err);
      });
  }

  function submitDataRemove() {
    var datos = [];

    datos.push({
      idData: tag_id,
    });

    fetch(URIDelete + URIExtension, {
      method: 'DELETE',
      credentials: 'same-origin',
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.success) {
          setAlert(json.message);
          props.recibir();
        } else {
          setAlert(json.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleSubmitEdit = (evt) => {
    evt.preventDefault();
    submitDataEdit();
  };
  const handleSubmitRemove = (evt) => {
    evt.preventDefault();
    submitDataRemove();
  };
  const modalEdit = useRef(null);
  const modalRemove = useRef(null);

  return (
    <>
      <a
        className='text-gray-600 py-1 px-3'
        href=' '
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
          dropdownPopoverShow
            ? closeDropdownPopover()
            : setIsComponentVisible(true);
        }}>
        <i className='fas fa-ellipsis-v'></i>
      </a>

      <div
        ref={popoverDropdownRef}
        className={
          'bg-white text-base z-50 float-left py-2 list-none text-left rounded-md shadow-lg w-36 ' +
          (dropdownPopoverShow ? 'message-globe' : 'hide-message')
        }>
        {isComponentVisible && (
          <div ref={ref}>
            <a
              href=' '
              className={
                'edit-option text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800'
              }
              onClick={(e) => {
                e.preventDefault();
                modalEdit.current.open();
              }}>
              <i className='far fa-edit mr-2'></i>
              Editar
            </a>
            <a
              href=' '
              className={
                'delete-option text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800'
              }
              onClick={(e) => {
                e.preventDefault();
                modalRemove.current.open();
              }}>
              <i className='fas fa-eraser mr-2'></i>
              Eliminar
            </a>
          </div>
        )}
      </div>
      <Modal ref={modalEdit}>
        <form onSubmit={handleSubmitEdit}>
          <div className='text-gray-300 font-bold md:text-left mb-1 md:mb-0 pr-4'>
            Editar {info}
          </div>
          <div className='my-4 md:block flex items-center justify-center max-w-full'>
            <label
              htmlFor={'nombre' + info}
              className='text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 max-w-1/2 w-1/2 inline-block'>
              {tagNombre}
            </label>
            <input
              className='bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 max-w-1/2 w-1/2 inline-block'
              type='text'
              id={'nombre' + info}
              name={'nombre' + info}
              placeholder={'Nombre de ' + info}
              onChange={(e) => setTagCantidad(e.target.value)}
              value={tagCantidad}></input>
          </div>
          <div className='relative m-0 text-center'>
            <button
              type='button'
              className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3.5 rounded mr-2 whitespace-pre-line'
              onClick={() => modalEdit.current.close()}>
              Cerrar ventana
            </button>
            <button
              type='submit'
              className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3.5 rounded mr-2 whitespace-pre-line'
              // onClick={(e) => {e.preventDefault();}}
            >
              Guardar cambios
            </button>
          </div>
        </form>
      </Modal>
      <Modal ref={modalRemove}>
        <form onSubmit={handleSubmitRemove}>
          <div className='text-gray-300 font-bold md:text-left mb-1 md:mb-0 pr-4'>
            Eliminar {info}
          </div>
          <div className='my-4'>
            <label
              htmlFor={'nombre' + info}
              className='text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4'>
              En verdad desea eliminar este/a {info}?
            </label>
            <div className='my-4'>
              <div className='flex'>
                <button
                  type='button'
                  className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3.5 rounded mr-2 whitespace-pre-line'
                  onClick={() => modalRemove.current.close()}>
                  No, cerrar ventana
                </button>
                <button
                  type='submit'
                  className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3.5 rounded ml-2 whitespace-pre-line'
                  // onClick={(e) => {e.preventDefault();}}
                >
                  Si, deseo eliminarlo
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default StockTagsDropdown;
